import { fallbackFlags } from 'config/launch-darkly-config';
import type { TAdobeTargetOffers } from 'api/models/TAdobeTarget';
import PrivacyService from 'services/PrivacyService';

import type { AdobeTarget } from 'global';

type TExperimentFlag = keyof typeof fallbackFlags;

const { VITE_AT_PROPERTY } = import.meta.env;

export async function waitForAdobeTarget(
  timeout = 5000
): Promise<AdobeTarget | undefined> {
  return await new Promise((resolve, reject) => {
    const interval = 50;
    let elapsed = 0;

    const check = () => {
      const atJS = typeof window !== 'undefined' && window.adobe?.target;
      if (atJS) {
        resolve(atJS);
      } else if (elapsed >= timeout) {
        reject('Timed out waiting for window.adobe.target');
      } else {
        elapsed += interval;
        setTimeout(check, interval);
      }
    };

    check();
  });
}

export async function getAdobeTargetOffer(
  mboxName: TExperimentFlag
): Promise<TAdobeTargetOffers> {
  try {
    const isAdobeTargetAllowed = PrivacyService.isAdobeTargetAllowed();

    const atJS = await waitForAdobeTarget();

    if (!isAdobeTargetAllowed) {
      return Promise.reject(`AdobeTarget not allowed: ${mboxName}`);
    }

    const promise: Promise<TAdobeTargetOffers> = new Promise(
      (resolve, reject) => {
        atJS?.getOffer({
          mbox: mboxName,
          params: {
            at_property: VITE_AT_PROPERTY
          },
          success: (response) => {
            resolve(
              (response as TAdobeTargetOffers).filter(
                ({ action }) => action === 'setJson'
              ) as TAdobeTargetOffers
            );
          },
          error: reject
        });
      }
    );

    return promise;
  } catch (e: unknown) {
    return Promise.reject((e as Error).toString());
  }
}
